import React, { useState } from "react";
import { FlexColumn } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import { SmallArrowIcon } from "@/assets/icons";
import Input from "@/ui/Input/Input";
import Button from "@/ui/Button/Button";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import { useUserDataContext } from "@/store/UserProvider";
import { setUserEmail } from "@/api/user";
import { getConfirmPaymentLink } from "@/api/payments";
import { showNotification } from "@/utils/network";
import { isEmailValid } from "@/utils/helpers";
import { useTranslation } from "react-i18next";
import { useChoosePaymentOptionsContext } from "./ChoosePaymentOptionsContext";
import cls from "./styles.module.scss";

export function AddNewCardPage() {
  const { t } = useTranslation();
  const { user } = useUserDataContext();
  const { goBack } = useChoosePaymentOptionsContext();
  const [email, setEmail] = useState(user?.mail || "");
  const [isLoading, setIsLoading] = useState(false);
  const isValid = isEmailValid(email);

  const addNewCard = async () => {
    setIsLoading(true);

    try {
      if (email) await setUserEmail({ mail: email });
      const res = await getConfirmPaymentLink();
      window.location.href = res;
    } catch (e) {
      console.error(e);
      showNotification({
        type: "error",
        text: t("paymentOptions.unableToAddNewPaymentOption"),
      });
      setIsLoading(false);
    }
  };

  return (
    <FlexColumn gap={24} className={cls.paymentOptionBlock}>
      <button type="button" className={cls.btnArrow} onClick={goBack}>
        <SmallArrowIcon />
      </button>
      <Typography className={cls.heading}>
        {t("paymentOptions.addNewCard")}
      </Typography>
      <Typography className={cls.desc}>
        {t("paymentOptions.confirmEmail")}
      </Typography>
      <Input
        value={email}
        onChange={setEmail}
        label="Email"
        placeholder={t("common.emailForCheck")}
        error={email && !isEmailValid(email) ? t("common.incorrectEmail") : ""}
      />
      <div className={cls.confirmBtn}>
        {!isLoading ? (
          <Button
            onClick={addNewCard}
            label={t("paymentOptions.confirmAndBind")}
            disabled={!isValid}
          />
        ) : (
          <ContainerLoader />
        )}
      </div>
    </FlexColumn>
  );
}
